import axios from 'axios';
import { SubjectTeacher } from 'src/models';

import { BASE_URL } from './config';
const ENDPOINT = '/api/upload';

export async function uploadProgressFile(
  file: File,
  employeeId: string,
  progress: string,
  subject: SubjectTeacher
) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  // Prepare the form data
  const formData = new FormData();
  formData.append('file', file);
  formData.append('employee_id', employeeId);
  // The backend FileMetadata expects field "Progress" (not "avance")
  formData.append('progress', progress);

  // Add the subject data using the backend's keys
  formData.append('SubjectCode', subject.SubjectCode);
  formData.append('SubjectName', subject.SubjectName);
  formData.append('Group', subject.Group);
  formData.append('Plan', subject.Plan);
  formData.append('Academy', subject.Academy);

  return apiClient.post(ENDPOINT, formData);
}
